<template>
  <a-modal
    :visible="visible"
    :width="780"
    :closable="false"
    :maskClosable="false"
    :footer="null"
    @cancel="handleClose"
    wrapClassName="pay-notify-modal-wrap"
  >
    <template slot="title">
      <div class="custom-modal-header">
        <span class="header-title">缴费通知</span>
        <span class="header-close" @click="handleClose">&times;</span>
      </div>
    </template>
    <div class="modal-container">
      <!-- 内容区域 -->
      <div class="modal-body">
        <!-- 上半部分：缴费通知内容 -->
        <div class="pay-notify-content" v-html="content"></div>
        <!-- 中间分隔图片 -->
        <div class="notify-divider-img">
          <img src="/static/images/pay-notify-divider.png" alt="" />
        </div>
        <!-- 下半部分：缴费说明 desc -->
        <a-spin :spinning="descLoading">
          <div class="pay-desc-content" v-if="desc" v-html="desc"></div>
        </a-spin>
      </div>
      <!-- 自定义 Footer -->
      <div class="modal-footer">
        <button class="btn-primary" @click="handleGoPay">去缴费</button>
        <button class="btn-primary" @click="handleGoRegister">去登记</button>
        <button class="btn-primary" @click="handleGoLearn">去学习</button>
        <button class="btn-secondary" @click="handleClose">关闭</button>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'PayNotifyModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      desc: '',
      descLoading: false,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.fetchDesc();
      }
    },
  },
  methods: {
    fetchDesc() {
      this.descLoading = true;
      this.desc = '';
      this.axios
        .get('/biz/user/pay/get?type=1')
        .then(res => {
          this.descLoading = false;
          if (res.result && res.result.desc) {
            this.desc = res.result.desc;
          }
        })
        .catch(() => {
          this.descLoading = false;
        });
    },
    dismissNotify() {
      this.axios.get('/biz/user/pay/notifyDismiss').catch(() => {});
    },
    handleGoPay() {
      this.$emit('goPay');
    },
    handleGoRegister() {
      this.$emit('goRegister');
    },
    handleGoLearn() {
      this.dismissNotify();
      this.$emit('close');
    },
    handleClose() {
      this.dismissNotify();
      this.$emit('close');
    },
  },
};
</script>

<style lang="stylus" scoped>
.modal-container
  background #fff

.custom-modal-header
  background #fff
  padding 16px 20px
  display flex
  justify-content space-between
  align-items center
  .header-title
    color #333
    font-size 16px
    font-weight 600
  .header-close
    color #333
    font-size 22px
    cursor pointer
    line-height 1
    opacity 0.85
    &:hover
      opacity 1

.modal-body
  padding 20px 24px

.pay-notify-content
  font-size 14px
  line-height 1.8
  color #333
  word-break break-word
  overflow-x auto

  >>> table
    border-collapse collapse
    td, th
      padding 8px 12px
      border 1px solid #e8e8e8
      white-space nowrap

.notify-divider-img
  width 100%
  margin 16px 0
  img
    width 100%
    height auto
    display block

.pay-desc-content
  font-size 14px
  line-height 1.8
  color #333
  word-break break-word
  overflow-x auto
  padding-top 8px

  >>> table
    border-collapse collapse
    td, th
      padding 8px 12px
      border 1px solid #e8e8e8
      white-space nowrap

.modal-footer
  display flex
  justify-content center
  align-items center
  gap 10px
  padding 16px 24px 20px

.btn-primary
  background #1890ff
  color #fff
  border none
  border-radius 22px
  padding 0 24px
  min-width 100px
  height 36px
  cursor pointer
  font-size 14px
  outline none
  &:hover
    background #096dd9 !important

.btn-secondary
  background #fff
  color #666
  border 1px solid #e8e8e8
  border-radius 22px
  padding 0 24px
  min-width 100px
  height 36px
  cursor pointer
  font-size 14px
  outline none
  &:hover
    background #E6F7FF
    color #1890ff
</style>

<style lang="stylus">
.pay-notify-modal-wrap
  .ant-modal
    max-width 90vw
  .ant-modal-content
    border-radius 14px
    overflow hidden
    max-height 90vh
    display flex
    flex-direction column
  .ant-modal-header
    padding 0
    background transparent
    border-bottom 1px solid #e8e8e8
    flex-shrink 0
  .ant-modal-body
    padding 0
    background #fff
    flex 1
    overflow-y auto
  .ant-modal-footer
    display none
  .ant-modal-close
    display none
  .btn-primary:hover
    background #096dd9 !important
</style>



// WEBPACK FOOTER //
// src/pages/home/components/PayNotifyModal.vue